/* ==========================================================================
   SelectPanel > Client > select
   ========================================================================== */

/* Modules */
// const { elementScrollIntoView } = require('seamless-scroll-polyfill');
const { addData } = require('@bluekiri/alexandria/helpers/dataHelpers');
const SelectTemplate = require('@bluekiri/alexandria-contrib-components/components/select-rxjs/template');
const SelectClient = require('@bluekiri/alexandria-contrib-components/components/select-rxjs/client/js');
const SelectActions = require('@bluekiri/alexandria-contrib-components/components/select-rxjs/client/js/store/actions');

const { types } = require('../store/actions');

const configuration = require('../config');

// function scrollToSelected(instance) {
//     if (!instance.select) return;

//     const { choiceId } = instance.select.choices.getValue() || {};

//     if (!choiceId) return;

//     const choiceSelected = instance.select.element.querySelector(`[data-id="${choiceId}"]`);

//     if (!choiceSelected) return;

//     /* Scroll */

//     // elementScrollIntoView(choiceSelected, { behavior: 'smooth', block: 'center' });
// }

function createSelect(instance) {
    const { config = {} } = instance;
    const { context = {}, literals = {} } = config;

    const { items = [] } = instance.store.select('data');

    const dataSelect = addData({ config: { literals }, items }, { type: configuration().type.select });

    return SelectTemplate(dataSelect, context);
}

function initSelect(instance) {
    const inst = instance;
    const { config = {} } = instance;
    const { choices = {} } = config;
    const { panelType } = instance.store.select('data');

    inst.select = SelectClient(
        `[data-type="${panelType}"] [data-component="SelectRxjs"][data-type="${configuration().type.select}"]`,
        { choices }
    );

    if (!inst.select) return;

    inst.select.choices.showDropdown();

    // scrollToSelected(instance);

    /* Extends reactions */
    inst.reactions = {
        ...inst.reactions,
        setOptions: inst.store.subscribe((state, action) => {
            if (action.type !== types.SET_OPTIONS) return;

            inst.actions.closePanel();
        }),
        change: inst.select.store.subscribe((state, action) => {
            if (action.type !== SelectActions.types.SELECT_OPTION) return;

            const {
                value: { value }
            } = inst.select.store.select('select');

            inst.actions.changeValue(value);
        })
    };
}

function destroySelect(instance) {
    const inst = instance;

    if (!instance.select) return;

    /* Destroy */
    instance.select.actions.destroy();

    /* Unsubscribe */
    instance.reactions.change.unsubscribe();

    /* Remove references */

    delete inst.select;
    delete inst.reactions.change;
}

module.exports = {
    createSelect,
    initSelect,
    destroySelect
};
